<template>
  <div class="the-earned-effect" v-if="$root.dataReady">
    <div class="hero">
      <div class="header">
        <img
          class="logo"
          height="76"
          src="https://webershandwick.co.uk/wp-content/uploads/2023/03/weber_w_logotype_rgb_white.png"
          width="76"
        />
        <a class="button" href="#link-4">Get in touch</a>
      </div>
      <div class="container">
        <div class="text">
          <h1
            class="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            The Era of Earned
          </h1>
        </div>
      </div>
      <div
        class="bg"
        :class="page.acf.hero_picture_position"
        :style="{
          'background-image':
            'url(https://webershandwick.co.uk/wp-content/uploads/2023/11/WSW_EarnedEffectStudy_151123_HeroBanner50%EF%BF%BD.png)',
        }"
      ></div>
    </div>

    <template v-for="(block, index) in blocks">
      <component
        :id="`link-${index}`"
        :is="block.acf_fc_layout"
        :key="index"
        :blockdata="block"
      ></component>
    </template>
  </div>
</template>

<script>
import Block from "../components/Block.vue";
export default {
  name: "the-earned-effect",
  data() {
    return {
      blocks: null,
      page: null,
    };
  },
  components: {
    Block,
  },
  created: function () {
    this.$root.dataReady = false;
    this.$root.headeriswhite = false;
    this.$root.headerIsVisible = false;
    this.$root.smallFooter = true;
  },
  mounted() {
    this.fetchData();
  },
  updated: function () {
    if (this.$root.dataReady) {
      $("div.wpcf7 > form").each(function () {
        var $form = $(this);
        wpcf7.init($form[0]);
        if (wpcf7.cached) {
          wpcf7.refill($form);
        }
      });
    }
  },
  props: ["slug"],
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
        function (response) {
          self.blocks = response[0].acf.block_grid;
          self.page = response[0];
          self.setTitle(response[0].title.rendered);
          self.$root.dataReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setTitle: function (title) {
      title = title.normalize("NFD").replace("&#038;", "&");
      document.title = title + " - Weber Shandwick";
    },
  },
};
</script>



// WEBPACK FOOTER //
// TheEarnedEffect.vue?5343009b